// Actions are payloads of information that send data from your application to your store.
// They are the only source of information for the store.

export const setShowNav = setValue => ({
  type: "SET_SHOW_NAV",
  payload: setValue,
});

export const setPageName = setValue => ({
  type: "SET_PAGE_NAME",
  payload: setValue,
});
